import { useState } from 'react';
import './CategoryButton.css'

const CategoryButton = ({categoryButton, color, hoverColor, selectedColor, selected, setSelected}) => {
    const [hovered, setHovered] = useState(false);

    const getStyle = () => {
        if(categoryButton.disabled)
            return { color: "lightgrey",  borderColor: "lightgrey"};

        if(selected == categoryButton.index)
            return {borderColor: color, background: selectedColor };

        if(hovered)
            return {borderColor: color, background: hoverColor };
        else
            return {borderColor: color};
    }

    return (
        <div 
            onClick={() => { if(!categoryButton.disabled) setSelected(categoryButton.index) }}
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)} 
            className={`categoryButton`} 
            style={getStyle()}
        >
            {categoryButton.text}
        </div>
    )
}

export default CategoryButton;